// eslint-disable-next-line import/no-cycle
import { adminApi } from '@/includes/contentManagementApi';

export default {
  getHistoryByEmail(userEmail) {
    return adminApi.get('/travel-buddy-history', { params: { userEmail } });
  },

  getHistoryByUserId(userId) {
    return adminApi.get(`/travel-buddy-history/${userId}`);
  },

  exportHistory(params = {}) {
    return adminApi.get('/travel-buddy-history/export', {
      params,
      responseType: 'blob',
    });
  },

  getAuditLogs(params = {}) {
    return adminApi.get('/travel-buddy-audit-log', { params });
  },

  exportAuditLogs(params = {}) {
    return adminApi.get('/travel-buddy-audit-log/export', {
      params,
      responseType: 'blob',
    });
  },

  triggerMatching() {
    return adminApi.post('/scheduler/trigger/travel-buddy');
  },

  triggerCleanup() {
    return adminApi.post('/scheduler/trigger/travel-buddy-cleanup');
  },

  triggerCleanupForUser(userId) {
    return adminApi.post(`/scheduler/trigger/travel-buddy-cleanup/${userId}`);
  },

  triggerMatchingForSelected(userIds) {
    return adminApi.post('/scheduler/trigger/travel-buddy-selected', { userIds });
  },

  scanAnomalies() {
    return adminApi.get('/travel-buddy-anomalies/scan');
  },

  getAnomalyUserDetails(userId) {
    return adminApi.get(`/travel-buddy-anomalies/user/${userId}`);
  },

  repairAnomaly(repairType, userId, extraBody = {}) {
    return adminApi.post(`/travel-buddy-anomalies/repair/${repairType}`, { userId, ...extraBody });
  },

  repairAllAnomalies(userId) {
    return adminApi.post('/travel-buddy-anomalies/repair/all', { userId });
  },
};
